import { render, staticRenderFns } from "./AntPersonalesTable.vue?vue&type=template&id=0151733a"
import script from "./AntPersonalesTable.vue?vue&type=script&lang=js"
export * from "./AntPersonalesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports